import type { SVGProps } from 'react';
const SvgLocker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M4.078 6.64a.75.75 0 1 0 1.5 0zm6.344 0a.75.75 0 0 0 1.5 0zm1.656-.75H3.922v1.5h8.156zm-8.156 0c-.915 0-1.656.742-1.656 1.657h1.5c0-.086.07-.156.156-.156zM2.266 7.548v6.344h1.5V7.547zm0 6.344c0 .914.741 1.656 1.656 1.656v-1.5a.156.156 0 0 1-.156-.156zm1.656 1.656h8.156v-1.5H3.922zm8.156 0c.915 0 1.656-.742 1.656-1.656h-1.5c0 .086-.07.156-.156.156zm1.656-1.656V7.547h-1.5v6.344zm0-6.344c0-.915-.741-1.656-1.656-1.656v1.5c.086 0 .156.07.156.156zM5.578 6.64V4.375h-1.5v2.266zm0-2.266c0-.642.255-1.258.71-1.713l-1.061-1.06a3.92 3.92 0 0 0-1.149 2.773zm.71-1.713A2.42 2.42 0 0 1 8 1.953v-1.5c-1.04 0-2.038.413-2.773 1.149zM8 1.953c.642 0 1.258.255 1.713.71l1.06-1.061A3.92 3.92 0 0 0 8 .453zm1.713.71c.454.454.709 1.07.709 1.712h1.5c0-1.04-.413-2.038-1.149-2.773zm.709 1.712v2.266h1.5V4.375zM8 9.969c.29 0 .523.234.523.523h-1.5c0 .54.438.977.977.977zm.523.523c0 .29-.234.524-.523.524v-1.5a.977.977 0 0 0-.977.976zM8 11.47c.54 0 .977-.437.977-.977h-1.5c0-.289.234-.523.523-.523zm.977-.977A.977.977 0 0 0 8 9.516v1.5a.523.523 0 0 1-.523-.524z"
      fill="currentColor"
    />
    <circle fill="currentColor" cy={10.5} r={0.75} cx={8} />
  </svg>
);
export default SvgLocker;
